import React, { useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { withNav } from 'react-skeletal-nav';

const Nav = withNav(({ children, isInline, depth, isVisible }) => {
  if (!isInline && depth !== 1) {
    return null;
  }

  const isRouteRootOrIsVisible = depth === 1 || isVisible;

  const [ height, setHeight ] = useState(isRouteRootOrIsVisible ? 'auto' : 0);
  const [ open, setOpen ] = useState(isRouteRootOrIsVisible);

  useEffect(() => {
    if (open !== isRouteRootOrIsVisible) {
      setOpen(isRouteRootOrIsVisible);
      setHeight(!open ? 'auto' : 0);
    }
  }, [open, isRouteRootOrIsVisible]);

  return (
    <AnimateHeight duration={200} height={height} className="navigation__group">
      {children}
    </AnimateHeight>
  );
});

export default Nav;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Navigation/Nav/Nav.js